<template>
	<div id="app">
		<el-dialog
			title="指定订单同步"
			:visible.sync="outerVisible"
			width="30%"
            :before-close="closeHandle"
			>
			<div>
				<el-form ref="form"  :rules="rules" :model="form" label-width="100px">
					<el-form-item label="选择店铺" prop="shop" >
						<el-cascader
						    clearable
							v-model="form.shop"
							:options="shopList"
							filterable
							:filter-method="filterMethod"
							:props="{ children: 'shops',value:'shopId',label:'shopName'}"
							:show-all-levels="false">
						</el-cascader>
					</el-form-item>
					
					<el-form-item label="输入平台单号"   prop="desc">
						<!-- <el-input type="textarea" size="mini"  placeholder="多个订单号请用逗号隔开(比如:111,222,333)"   maxlength="6000"  v-model="form.desc"></el-input> -->
						<el-input v-model="form.desc" type="textarea" :rows="9" show-word-limit size='mini' clearable placeholder="多个订单号请用逗号隔开(比如:111,222,333)" ></el-input>
                            <div style="float: left; margin-top: 16px">
                                <span :style="{ color: form_numberStr_length ? (300>form_numberStr_length>0? '#171F25':'#FF573C') : '#d6d8d9'}"> {{form_numberStr_length||0}}/300 </span>
						    </div>		
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="mini" @click="submitForm('form')">开始同步</el-button>
						<!-- <el-button>取消</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {getShopsWithShopType,downloadByOrderIds } from '@/api/home'
export default {
	name: 'SyncOrder',
	components: {
	},
	props: {
		outerVisible: {
			type: Boolean,
            default: false,
		}
	},
	data() {
		return {
			form_numberStr_length:'',
			timer:null,
			timeNumber:0,
			form:{
				shop: '',
                desc: ''
			},
			shopList:[],
			rules: {
				shop: [
					{ required: true, message: '请选择店铺', trigger: 'change' }
				],
				desc: [
					{ required: true, message: '请输入订单号', trigger: 'blur' }
				]
			}
		}
	},
	watch:{
		/**
         * 订单号、记录号、物流单号、买家ID 支持批量筛选
         * */
        'form.desc':{
			handler(value, oldValue) {
				if (this.form_numberStrFilter().length > 200) {
					this.form.desc = oldValue;
				}
				this.form_numberStr_length = this.form_numberStrFilter().length;
            },
		}
	},
	methods: {
		// form_numberStrHandle() {
        //     this.form.numberStr = this.form_numberStrFilter().join(',');
        // },
        form_numberStrFilter() {
            let list = [];
            list = this.form.desc.split(/[,，\n]+/).filter((item) => {
                return item !== '' && item !== ' ';
            });
            return list;
        },
		filterMethod(node, keyword) {
			return node.label.toLowerCase().indexOf(keyword.toLowerCase()) >= 0;
		},
		closeHandle(){
			this.$emit('close');
		},
		clearParms(){
			this.form.shop= '';
            this.form.desc = '';
		},
		/**
		 * 开始同步
		 */
		submitForm(form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
				    let parms = {
						shopNick:'',
						shopName:'',
						shopType : '',
						onlineOrderIds:[],
						
					},newData=[];
					if(this.form.desc){
						newData = this.form_numberStrFilter().join(',');
						parms.onlineOrderIds = newData
					}
					this.shopList.forEach(res=>{
						res.shops.forEach(j=>{
							if(j.shopId === this.form.shop[1]){
								parms.shopNick = j.shopNick;
								parms.shopName = j.shopName;
								parms.shopType = j.shopType;
							}
						})
					})
					downloadByOrderIds(parms).then((res) => {
						if(res.success){
							this.$message.success('正在同步中....');
							this.$emit('pulling');
						}
				   }).catch((err) => {
						console.log(err);
					})
							
				} else {
					console.log('error submit!!');
					return false;
				}
			})
        },
		// form_numberStrFilter() {
        //     let list = [];
        //         list = this.form.desc.split(/[,，\n]+/).filter((item) => {
        //             return item !== '' && item !== '';
        //         });
        //     return list;
        // },
	},
	
	mounted() {},
	created() {
		getShopsWithShopType().then((res) => {
			let list = res.map((item) => {
                item.shopName = item.sourceType.name;
                item.shopCnName = item.sourceType.cnName;
                item.shopId = item.sourceType.type;
                return item;
            });
            list.sort((a, b) => {
                return a.sourceType.sequence - b.sourceType.sequence;
            });
            this.shopList = list;
		}).catch((err) => {
			console.log(err);
		})
	},
	destroyed() {
		clearInterval(this.timer)
	}
}
</script>

<style scoped >
::v-deep .el-form-item__label{
	font-size: 12px;
	line-height: 28px;
}
::v-deep .el-input__inner{
	height: 28px !important;
	line-height: 28px !important;
	font-size: 12px;
}
::v-deep .el-form-item__content,.el-cascader,.el-input__icon{
	line-height: 28px !important;
	
}
::v-deep .el-input__icon{
	line-height: 28px !important;
	
}
::v-deep .el-button--primary{
	border-color: #0869bd;
    background: #0869bd;
}
</style>
<style>
.el-cascader-menu__wrap{
	height: 350px !important;
}
</style>
